
define('text!templates/widgets/pager/pageCount.html',[],function () { return '<span class="page-count" data-bind="text: pageCount"></span>';});

